export default "__VITE_ASSET__e78e2d80__"